import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items = [] }) => {
    return (
        <nav
            aria-label="Fil d'Ariane"
            className="flex items-center gap-1.5 text-xs text-gray-400 mb-6 flex-wrap"
            data-testid="breadcrumbs"
        >
            <Link to="/" className="hover:text-[#00C853] transition-colors">
                Accueil
            </Link>
            {items.map((item, idx) => (
                <React.Fragment key={idx}>
                    <ChevronRight size={12} />
                    {item.to ? (
                        <Link
                            to={item.to}
                            className="hover:text-[#00C853] transition-colors"
                        >
                            {item.label}
                        </Link>
                    ) : (
                        <span className="text-gray-300">{item.label}</span>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
};

export default Breadcrumbs;
